import GenericVideoDialog from "./GeneralVideoDialog";
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {AskToJoinTeacherDialogId} from "./VideoChat";

@inject('videoChatStore')
@observer
export class AskToJoinTeacherDialog extends Component {
    render() {
        const {isOpen, closeDialog, handleClose, handleCancel, handleAccept, videoChatStore} = this.props;
        return <GenericVideoDialog dialogId={AskToJoinTeacherDialogId} isOpen={isOpen}
                                   onClose={closeDialog}
                                   titleKey={'video.chat.student.student.waiting.title'}
                                   textKey={'video.chat.student.student.waiting.text'}
                                   itemName={videoChatStore.peerUser?.name}
                                   buttonKey={'teacher.accept'}
                                   cancelButtonText={'teacher.decline'}
                                   handleCancel={handleCancel}
                                   handleClose={handleClose}
                                   handleAccept={handleAccept}
        />
    }
}